(() => {
  // app/scripts/header-nav.js
  !window.customElements.get("header-nav") && window.customElements.define(
    "header-nav",
    class extends HTMLElement {
      constructor() {
        super();
        const { resizeObserver } = theme;
        this.init();
        resizeObserver(
          this,
          () => {
            this.calHeight();
          },
          300
        );
      }
      connectedCallback() {
        this.calHeight();
      }
      init() {
        this.addEventListener(
          "mouseenter",
          (event) => {
            const parentLi = event.target.closest("li");
            const container = parentLi?.querySelector(".container");
            this.loadTemplateIfNeeded(container);
          },
          { once: true }
        );
        this.addEventListener(
          "focusin",
          (event) => {
            const parentLi = event.target.closest("li");
            const container = parentLi?.querySelector(".container");
            this.loadTemplateIfNeeded(container);
          },
          { once: true }
        );
      }
      loadTemplateIfNeeded(container) {
        if (!container || container.dataset.loaded === "true")
          return;
        const template = container.querySelector("template");
        if (!template)
          return;
        const content = template.content.cloneNode(true);
        content.querySelectorAll(".appear-animation").forEach((e) => {
          e.style.opacity = "0";
          e.style.transform = "translateY(60px)";
        });
        container.appendChild(content);
        setTimeout(() => {
          container.querySelectorAll(".appear-animation").forEach((e) => {
            requestAnimationFrame(() => {
              e.style.opacity = "";
              e.style.transform = "";
            });
          });
        }, 250);
        template.remove();
        container.dataset.loaded = "true";
      }
      // onNavHover(el) {
      //   const nav = el;
      //   const template = nav.parentNode.querySelector('.jsTemplate');
      //   if (!template) return;
      //   template.tagName == 'TEMPLATE' && Array.from(template.content.children)?.forEach(child => {
      //     template.insertAdjacentElement('beforebegin', child);
      //   })
      //   template.tagName == 'NOSCRIPT' && template.insertAdjacentHTML('beforebegin', template.textContent);
      //   template.remove();
      //   const parentNode = nav.parentNode;
      //   parentNode.classList.add('has-dropdown');
      //   parentNode.classList.toggle('has-mega-menu', parentNode.querySelector('[data-section-type="mega-menu"]'));
      //   parentNode.querySelector(':scope > a ~ template')?.remove();
      //   parentNode.querySelectorAll('a').forEach(a => {
      //     a.addEventListener('focusin', e => {
      //       a.classList.add('is-focusing');
      //     });
      //     a.addEventListener('focusout', e => {
      //       a.classList.remove('is-focusing');
      //       setTimeout(() => {
      //         !parentNode.querySelectorAll('.is-focusing').length && parentNode.classList.remove('is-focusing');
      //       }, 100)
      //     });
      //   })
      //   this.calHeight();
      // }
      calHeight() {
        const { offsetTop, clientHeight } = this;
        this.parentNode.style.setProperty("--bottom", offsetTop + clientHeight + 2 + "px");
      }
    }
  );
})();
